import { QUESTION_IDS } from "../constants/questions";
import type { Reviewer } from "../types";
import { isValidEmail } from "../utils/validation";

export const FREITEXT_MAX = 1000;

export interface FormState {
  ratings: Record<string, number>;
  freitext: string;
  reviewer: Reviewer;
  consent: boolean;
  displayConsent: boolean;
  anonymous: boolean;
}

export function createFormState(): FormState {
  const ratings: Record<string, number> = {};
  for (const id of QUESTION_IDS) ratings[id] = 0;
  return {
    ratings,
    freitext: "",
    reviewer: {
      firstName: "",
      lastName: "",
      email: "",
    },
    consent: false,
    displayConsent: false,
    anonymous: false,
  };
}

export function allRatingsAnswered(state: FormState): boolean {
  return QUESTION_IDS.every((id) => state.ratings[id] > 0);
}

export function isSubmitEnabled(state: FormState): boolean {
  return (
    allRatingsAnswered(state) &&
    isValidEmail(state.reviewer.email) &&
    state.consent
  );
}
